import Select from "react-select";
import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";

export const SelectOption = ({
  classLabel,
  classInput,
  options = [],
  defaultValue,
  value,
  label,
  isClearable = false,
  onChange,
  disabled,
  isMulti,
  max,
  labelComponent,
  error,
  info,
}) => {
  const [showErrorMessage, setShowErrorMessage] = useState(true);

  // useEffect(() => {
  //   setShowErrorMessage(!!error);
  // }, [error]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 999999 }),
    control: (provided, state) => ({
      ...provided,
      ...(!!error && showErrorMessage && { borderColor: "red" }),
    }),

    input: (provided, state) => ({
      ...provided,
    }),

    indicatorSeparator: (state) => ({}),

    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "50px",
      color: "hsl(0, 0%, 60%) !important",
    }),

    placeholder: (base) => ({
      ...base,
      textOverflow: "ellipsis",
      color: "#a9a9a9",
      overflow: "hidden",
      whiteSpace: "nowrap",
    }),

    valueContainer: (styles, state) => {
      return {
        ...styles,
        padding: "0 6px",
        minHeight: "50px",
        // textOverflow: "ellipsis",
        // maxWidth: "90%",
        // whiteSpace: "nowrap",
        // overflow: "hidden",
        // display: `${state.hasValue ? "initial" : "flex"}`,
      };
    },
  };

  const finalValue = _.isNil(value)
    ? null
    : isMulti
      ? options?.filter((c) => value.includes(c.value))
      : options?.find((c) => c.value === value);
  const isDisabledForMaxSelected = isMulti && finalValue.length >= max;

  return (
    <>
      <div className={"relative"}>
        <span className={"px-3 text-[12px] right-2 " + classLabel}>
          {label}
        </span>
        {labelComponent}
      </div>
      <Select
        className={classInput}
        isOptionDisabled={() => isDisabledForMaxSelected}
        styles={customStyles}
        options={options.filter((opt) => opt.isHide !== true)}
        value={finalValue}
        defaultValue={defaultValue}
        isSearchable={true}
        isRtl={true}
        placeholder={"انتخاب کنید"}
        isClearable={isClearable}
        onChange={(e) => {
          onChange?.(e);
        }}
        onInputChange={() => {
          // setShowErrorMessage(true);
        }}
        noOptionsMessage={() => "گزینه یافت نشد"}
        loadingMessage={() => "در حال دریافت اطلاعات"}
        isDisabled={disabled}
        isMulti={isMulti}
        menuPortalTarget={document.body}
      />
      {!showErrorMessage && !error && info && (
        <p className={"text-sm mt-2"}>{info}</p>
      )}
      {showErrorMessage && error && (
        <p className={"text-sm mt-2 text-red-600"}>{error}</p>
      )}
    </>
  );
};
